module.exports = __webpack_public_path__ + "static/media/Year-1039-background.33460821.jpg";